@if (isAuthenticated) {
  <div class="pages-container">
    <app-header id="header" />
    <div class="content-container">
      <aside class="side-nav">
        <app-side-nav id="side-nav" />
      </aside>
      <main class="router-container">
        <router-outlet />
        <app-global-loader [loading]="loading$ | async" />
      </main>
    </div>
  </div>
}
